var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "mobile_service_select",
      staticClass: "offcanvas offcanvas-right",
      attrs: { id: "mobile_service_select" },
    },
    [
      _c("button", {
        staticStyle: { display: "none" },
        attrs: { id: "mobile_service_select_toggle" },
      }),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-header d-flex align-items-center justify-content-between pb-5",
        },
        [
          _c("h4", { staticClass: "font-weight-bold m-0" }, [
            _vm._v(" " + _vm._s(_vm.$t("mobileServiceSelect.title")) + " "),
          ]),
          _c(
            "a",
            {
              attrs: { href: "#", id: "mobile_service_select_close" },
              on: {
                click: function ($event) {
                  return _vm.closeOffcanvas("mobile_service_select")
                },
              },
            },
            [_c("i", { staticClass: "ki ki-close icon-md" })]
          ),
        ]
      ),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "offcanvas-content mr-n5 scroll",
          staticStyle: { "max-height": "87vh", position: "relative" },
        },
        [
          _c("div", { staticClass: "bb-input-group search-input" }, [
            _c("i", { staticClass: "fas fa-search" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchTerm,
                  expression: "searchTerm",
                },
              ],
              attrs: {
                type: "text",
                placeholder: _vm.$t("mobileServiceSelect.searchPlaceholder"),
              },
              domProps: { value: _vm.searchTerm },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchTerm = $event.target.value
                },
              },
            }),
            _c(
              "button",
              {
                staticClass: "bb-badge badge-rounded",
                on: {
                  click: function ($event) {
                    _vm.searchTerm = ""
                  },
                },
              },
              [_c("i", { staticClass: "ki ki-close icon-md" })]
            ),
          ]),
          _c(
            "div",
            { staticClass: "service-categories-list" },
            _vm._l(_vm.displayServices, function (serviceCategory) {
              return _c(
                "div",
                {
                  key: serviceCategory.id,
                  staticClass: "service-category-item",
                },
                [
                  _c("span", { staticClass: "service-category-name" }, [
                    _vm._v(_vm._s(serviceCategory.name)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "services-list" },
                    _vm._l(serviceCategory.services, function (service) {
                      return _c(
                        "div",
                        {
                          key: service.id,
                          staticClass: "service-item",
                          on: {
                            click: function ($event) {
                              return _vm.selectService(service)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "service-item-left" }, [
                            _c("span", [_vm._v(_vm._s(service.name))]),
                            _c("small", [
                              _vm._v(_vm._s(service.duration + " minutes")),
                            ]),
                          ]),
                          _c("div", { staticClass: "service-item-right" }, [
                            _c("span", [
                              _vm._v(_vm._s(service.price + " RSD")),
                            ]),
                            _c("button", [
                              _c("i", { staticClass: "la la-angle-right" }),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c("div", { staticClass: "offcanvas-footer" }, [
        _vm.$hasRole(_vm.acl.roles.owner) ||
        _vm.$hasPermission(_vm.acl.permissions.manageAccount)
          ? _c(
              "button",
              {
                staticClass: "new-service-btn",
                on: {
                  click: function ($event) {
                    return _vm.createService({ placeId: _vm.currentPlace.id })
                  },
                },
              },
              [_c("i", { staticClass: "la la-plus" })]
            )
          : _vm._e(),
      ]),
      _c("ServiceFormModal", { ref: "serviceFormModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }